// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-225e8ab0] .el-dropdown-menu__item{line-height:25px;padding:3px 15px;font-size:14px;color:#7d7d7d}[data-v-225e8ab0] .el-dropdown-menu__item:not(.is-disabled):hover{color:#0c3a93;background:#fff}", ""]);
// Exports
module.exports = exports;
